import { Component } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import {
  MarketDrawerRootReducerState,
  getUSTreasuriesSelectedState,
  getUSTreasuriesLoadingState
} from '../../../../state/reducer';
import { USTreasury } from '../../../../models/us-treasury';

@Component({
  selector: 'muni-gameday-market-drawer-ust-header',
  templateUrl: './ust-header.template.html',
  styleUrls: ['./ust-header.styles.scss']
})
export class USTHeaderComponent {
  public readonly selected: Observable<USTreasury> = this.store.pipe(
    select(getUSTreasuriesSelectedState),
    distinctUntilChanged()
  );

  public readonly loading: Observable<boolean> = this.store.pipe(
    select(getUSTreasuriesLoadingState),
    distinctUntilChanged()
  );

  constructor(private store: Store<MarketDrawerRootReducerState>) {}
}
